import classNames from "classnames";
import { AscFindTheWordsPuzzleWord } from "@ascendnow/shared";
import styles from "./AscFindTheWordsPuzzleClueList.module.scss";

export interface AscFindTheWordsPuzzleClueListProps {
  className?: string;
  words: AscFindTheWordsPuzzleWord[];
  foundWords?: AscFindTheWordsPuzzleWord[];
  title?: string;
  mode?: "create" | "solve";
}

export default function AscFindTheWordsPuzzleClueList({
  className,
  words,
  foundWords = [],
  title = "Answer questions & find the words",
  mode = "solve",
}: AscFindTheWordsPuzzleClueListProps) {
  return (
    <div
      data-testid={`asc-find-the-words-puzzle-clue-list`}
      className={classNames(styles.ground, className)}
    >
      {words?.length ? (
        <>
          {mode === "solve" ? (
            <div className={styles.title}>{title}</div>
          ) : null}
          <div className={styles.clueList}>
            {words?.map((word, index) => (
              <div
                className={classNames(styles.clueItem, {
                  [styles.found]: foundWords?.find(
                    (w) => w?.wordIndex === word?.wordIndex
                  ),
                })}
                key={word?.wordIndex}
              >
                <span>{index + 1}</span>
                <span>{word?.clue || word?.word}</span>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
